import { render } from "./TextMessageForm.vue?vue&type=template&id=547bd29e"
import script from "./TextMessageForm.vue?vue&type=script&lang=ts"
export * from "./TextMessageForm.vue?vue&type=script&lang=ts"

import "./TextMessageForm.vue?vue&type=style&index=0&id=547bd29e&lang=scss"
script.render = render

export default script